import { position } from '@shared/meta/widget/options.js'

export default {
  data: function() {
    return {
      containerStylesObject: {
        justifyContent: '',
        alignItems: '',
      },
      positionOptions: position,
    }
  },
  methods: {
    setWidgetPosition: function(widget) {
      const styleMap = {
        [this.positionOptions.TOP_LEFT]: { justifyContent: 'flex-start', alignItems: 'flex-start' },
        [this.positionOptions.TOP_CENTER]: { justifyContent: 'flex-start', alignItems: 'center' },
        [this.positionOptions.TOP_RIGHT]: { justifyContent: 'flex-start', alignItems: 'flex-end' },
        [this.positionOptions.CENTER_LEFT]: { justifyContent: 'center', alignItems: 'flex-start' },
        [this.positionOptions.CENTER]: { justifyContent: 'center', alignItems: 'center' },
        [this.positionOptions.CENTER_RIGHT]: { justifyContent: 'center', alignItems: 'flex-end' },
        [this.positionOptions.BOTTOM_LEFT]: { justifyContent: 'flex-end', alignItems: 'flex-start' },
        [this.positionOptions.BOTTOM_CENTER]: { justifyContent: 'flex-end', alignItems: 'center' },
        [this.positionOptions.BOTTOM_RIGHT]: { justifyContent: 'flex-end', alignItems: 'flex-end' },
      };

      const position = widget.settings.position;
      const styles = styleMap[position] || {}; // Fallback to empty object if position is not defined

      // Apply the styles from the map
      this.containerStylesObject.justifyContent = styles.justifyContent;
      this.containerStylesObject.alignItems = styles.alignItems;
    },
  },
}